<template>
<v-dialog v-model="show" :persistent="pers" :width="width" :dark="false">
    <v-card>
        <v-card-title style="backgroundj:#f5f5f5;font-weight:bold">
            {{title}}

            <v-spacer></v-spacer>
            <slot name="header-actions">

            </slot>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text id="rptnView">
             <slot name="content">

            </slot>
        </v-card-text>
        <v-card-actions>
             <v-spacer></v-spacer>
             <slot name="footer-actions">

            </slot>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
export default {
    name:'dialog',
    props:{
        title:String,
        width:{
            type:String,
            default:"70%",
        },
        show:{
            type:Boolean,
            default:false,
        },
        pers:{
            type:Boolean,
            default:true,
        }

    },

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/RptModal.vue